import { Loader } from 'component/customComponents/loader/loader';
import React, { ComponentProps, ReactElement, Suspense, lazy } from 'react';

const LazyStudentJournalData = lazy(() =>
  import('./StudentJournalData')
    .then((module) => ({ default: module.StudentJournalData }))
    .catch(() => {
      document.location.reload();
      return { default: (): JSX.Element => <></> };
    })
);

export const StudentJournalData = (
  props: ComponentProps<typeof LazyStudentJournalData>
): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentJournalData {...props} />
  </Suspense>
);
